/**
 * Component: AssetList.jsx
 * Description: This component is utilized for Listing the all asset in the grid with Edit,Delete and View buttons.
 */

import styled from "@emotion/styled";
import { Box, Button, Grid, Paper, Typography, Stack, IconButton, Dialog, DialogTitle, DialogContentText, Checkbox, FormControlLabel, DialogContent, DialogActions, FormGroup, Chip } from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { DefaultCard } from "../../assets/styled-components/card";
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import {
  clearAttachmentDetails,
  gridValues,
  mandatoryFields,
  serviceType,
  updateAssetSpecification,
  updateBasicDetails,
  updatePurchaseDetails,
} from "../../redux/actions/assetActions";
import AssetRepository from "../../api/repositories/assetRepository";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import CustomDialog from "../commoncomponents/CustomDialog";
import PageTitle from "../commoncomponents/PageTitle";
import CloseButton from "../commoncomponents/CloseButton";
import { ErrorChips, InfoChips, SuccessChips, WarningChips } from "../../assets/styled-components/chips";
import PageLoader from "../commoncomponents/PageLoader";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PriorityHighOutlinedIcon from '@mui/icons-material/PriorityHighOutlined';
import CustomTooltip from "../commoncomponents/CustomTooltip";

const AssetList = () => {
  const location = useLocation();
  const { code, service } = location.state || "";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [workGroupdetail, setWorkGroupDetail] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [workGroup, setWorkGroup] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState({});
  const [activeCard, setActiveCard] = useState({
    all: true
  });
  const [gridLoader, setGridLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const [filterModel, setFilterModel] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportCount, setExportCount] = useState(0)
  const [riskChecks, setRiskChecks] = useState({
    patientImpact: false,
    hazardRisk: false,
    failedSafety: false,
    highRepairCost: false,
    badCondition: false,
    breakdownFreq: false,
  });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [assetCondition, setAssetCondition] = useState("Good");
  const [assetRiskData, setAssetRiskdata] = useState("");
  const [riskDialogOpen, setRiskDialogOpen] = useState(false);
  const [assetTotalCount, setAssetTotalCount] = useState(0)
  const [errorRiskDialogOpen, setErrorRiskDialogOpen] = useState(false);
  const [errorRiskMessage, setErrorRiskMessage] = useState("");
  const assetCategoryType = useSelector(
    (state) => state?.serviceType?.assetType
  );
  //To get the URL path to classfy the Asset type
  const url = window.location.pathname;
  dispatch(serviceType(url));
  const [wgCode, setWgCode] = useState('');

  useEffect(() => {
    if (location.state && code) {
      handleAssetCardClick(code);
    }
    else if (workGroup?.length > 0 && !activeCard?.all) {
      handleAssetCardClick(wgCode); //changes
    }

  }, [code, workGroup, filterModel, sortModel, pageIndex, pageSize, assetCategoryType]);


  // default values for basic details
  const intialBaiscDetails = {
    rentalStatus: { label: "No", key: "option2", default: true }, //setting the default value
    tcNo: "",
    tcOldNo: "",
    assetClassification: {
      key: "option1",
      id: 1,
      label: "Asset",
      isloanerasset: false,
    }, //setting the default value for asset classification when rentalStatus is No
    financeAssetNo: "",
    assetDescription: "",
    typecode: "",
    typeCodeDescription: "",
    locationName: "",
    locationNo: "",
    userDepartment: "",
    departmentDescription: "",
    criticality: "",
    workGroup: "",
    ppmRequired: { label: "Yes", key: "option1", default: true }, //setting the default value
    ppmStatus: { label: "In House", key: "option2", isvisible: true, id: 2 },
    parentAssestNo: "",
    description: "",
    reason: "",
    isauthorized: false,
    assetValue: "",
    oldAssetNo: "",
    id: "",
    medicalequipmentcategory: { label: "", value: "", id: "" },
  };

  // default values for asset specification
  const initailAssetSpecification = {
    make: "",
    brand: "",
    model: "",
    serialNo: "",
    version: "",
    engineNo: "",
    chassisNo: "",
    manufacturer: "",
    registrationNo: "",
    capacity: "",
    assetStatus: { id: 1, label: 'Functioning ', isvisible: true },
    lifeSpan: "",
    depreciationValue: "",
    buildupArea: "",
    footPrint: "",
    landArea: "",
    isDataSetInEditMode: false,
  };

  // default values for purchase details
  const initialPurchaseDetails = {
    warrantyStartDate: "",
    warrantyEndDate: "",
    commissioningDate: "",
    warranty: "",
    vendor: "",
    purchaseOrderNo: "",
    purchaseCost: "",
    accessories: "",
    cumulativePartCost: null,
    cumulativeLabourCost: null,
    lastUnscheduledWorkOrder: "",
    lastScheduledWorkOrder: "",
    assetTransferCategory: "",
    purchaseFlag: "",
    assetTransferDepartment: "",
    underWarrenty: false,
    isDataSetInEditMode: false,
    isTCFieldSet: false,
    assetriskcondition: "",
  };

  const initialAttachmentDetails = [];

  const isFems = assetCategoryType === "/assetsFEM"

  const accessDataFem = useAccess();
  const accessFem = utilities.getScreenPermissions(accessDataFem, "ENGM013");
  const accessDataBem = useAccess();
  const accessBem = utilities.getScreenPermissions(accessDataBem, "ENGM014");
  const accessDataBemchecklist = useAccess();

  const setInitialValuesForAllPages = () => {
    dispatch(gridValues({ values: {}, isEdit: false, isView: false }));
    dispatch(updateBasicDetails("UPDATE_BASIC_DETAILS", intialBaiscDetails));
    dispatch(
      updateAssetSpecification(
        "UPDATE_ASSET_SPECIFICATION",
        initailAssetSpecification
      )
    );
    dispatch(
      updatePurchaseDetails("UPDATE_PURCHASE_DETAILS", initialPurchaseDetails)
    );
    dispatch(
      clearAttachmentDetails(
        "CLEAR_ATTACHMENT_DETAILS",
        initialAttachmentDetails
      )
    );
  };

  //To get the facility ID from Local storage
  const facilityId = getFacilityId("facilityId");

  // Fetch the Grid Values from API
  const fetchData = async (assetType, pageIndex, pageSize, filterModel, sortModel) => {
    try {
      setGridLoader(true);
      const response = await AssetRepository.assetListing(assetType, pageIndex, pageSize, filterModel, sortModel);
      setRows(response?.items);
      setFilteredRows(response?.items);
      setRowCount(response?.totalCount);
      setAssetTotalCount(response?.assetTotal)
    } catch (error) {
      console.error("Failed to fetch asset data:", error);
    } finally {
      setGridLoader(false);
    }
  };

  //Fetch the Work Group Code from API
  const WorkGroupCode = async (assetType, id) => {
    try {
      const response = await AssetRepository.workGroupCodeDetails(
        assetType,
        id
      );
      setWorkGroup(response);
    } catch (error) {
      console.error("Failed to fetch asset data:", error);
    }
  };

  const handleSwitchChange = () => {
    // Access the checked state of the switch using event.target.checked
    // Perform actions based on the switch state (isChecked)
    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
  };

  useEffect(() => {
    if (activeCard?.all) {
      fetchData(assetCategoryType, pageIndex, pageSize, filterModel, sortModel);
    }
  }, [filterModel, sortModel, pageIndex, pageSize, assetCategoryType])

  useEffect(() => {
    handleSwitchChange();
    gridApi?.setFilterModel('');
    setActiveCard({ all: true });
    setErrorMessage("");
    setRowToDelete({});
    setDeleteDialogOpen(false);
    setWorkGroupDetail([]);
    setWorkGroup([]);
    setRows([]);
    setFilteredRows([]);
    // fetchData(assetCategoryType);
    WorkGroupCode(assetCategoryType, facilityId);
    setInitialValuesForAllPages();
    handleAssetCardClick();
    //for pagination
    setPageIndex(1);
    setPageSize(10);
    setFilterModel([]);
    setSortModel([]);
  }, [assetCategoryType]);

  // AssetCard  for display diffrent types for workgroup details
  const AssetCard = styled(Box)(({ theme }) => ({
    display: "grid",
    maxWidth: "1200px",
    gridTemplateColumns: "repeat(6,1fr)",
    gap: "8px",
    "@media screen and (max-width: 1200px)": {
      gridTemplateColumns: "repeat(4, 1fr)",
    },
    "@media screen and (max-width: 780px)": {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
    "@media screen and (max-width: 700px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media screen and (max-width: 550px)": {
      gridTemplateColumns: "repeat(1, 1fr)",
    },
  }));

  // Each WorkGroupCode CardItem
  const AssetCardItem = styled(Paper)(({ theme }) => {
    return {
      backgroundColor: "background.paper",
      boxShadow: "none",
      border: "1px solid #EFEEF0",
      minHeight: "100px",
      cursor: "pointer",
      display: "inline-flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: "16px",
      borderRadius: "0px",
      "&>p,&>h2": {
        fontSize: "12px",
        margin: 0,
        marginTop: "auto",
      },
      "&.active": {
        backgroundColor: theme.palette.primary.hover,
      },
      "&:not(.active):hover": {
        backgroundColor: theme.palette.primary.hover,
        "& .MuiTypography-h2": {
          color: theme.palette.primary.main,
        },
      },
    };
  });

  // Asset List Grid Field Values
  const columnNames = [
    { field: "assetNo", headerName: "Asset No" },
    { field: "assetDescription", headerName: "Asset Description" },
    { field: "assetClassificationCode", headerName: "Asset Classification" },
    // { field: "workgroup", headerName: "Work Group" },
    // { field: "assetTypeCode", headerName: "Asset Type Code" },
    { field: "oldassetno", headerName: "Old Asset No" },
    //  { field: "userLocationCode", headerName: "Location Code" },
    //  { field: "userDepartmentCode", headerName: "Department Code" },
    { field: "userLocationDesc", headerName: "Location Description" },
    { field: "userDescription", headerName: "Department Description" },
    { field: "assetFinanceNo", headerName: "Asset Finance No" },
    { field: "vendor", headerName: "Vendor" },
    { field: "status", headerName: "Asset Status" },
    //{ field: "ppmstatus", headerName: "PPM Status" },
    { field: "model", headerName: "Model" },
    { field: "serialNumber", headerName: "Serial Number" },
    { field: "manufacturer", headerName: "Manufacturer" },
    {
      field: "authorizedStatus",
      headerName: "Status",
      cellRenderer: (params) => {
        if (params?.value === "Authorized") {
          return <SuccessChips label={params.value} />;
        } else if (params?.value === "UnAuthorized") {
          return <ErrorChips label={params.value} />;
        }
      },
    },
    ...(assetCategoryType === "/assetsBEM"
      ? [{
        field: "assetRiskLevel", headerName: "Risk Level", cellRenderer: (params) => {
          if (params?.value === "Low Risk") {
            return <SuccessChips label={params.value} />;
          } else if (params?.value === "Moderate Risk") {
            return <WarningChips label={params.value} />;
          } else if (params?.value === "High Risk") {
            return <ErrorChips label={params.value} />
          }
        },
      }]
      : []),
    ...(assetCategoryType === "/assetsBEM"
      ? [{
        field: "checklistStatus", headerName: "Checklist Status",
      }
      ]
      : []),
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      cellClassName: "actions",
      minWidth: assetCategoryType === "/assetsBEM" ? 200 : 150,
      filter: false,
      cellRenderer: (params) => {
        const now = new Date();
        const currentMonth = now.getMonth(); // 0 = Jan, 5 = June, 6 = July
        const currentDate = now.getDate();
        const currentYear = now.getFullYear();


        const canDelete = isFems ? accessFem.canDelete : accessBem.canDelete;
        const canEdit = isFems ? accessFem.canEdit : accessBem.canEdit;
        const canView = isFems ? accessFem.canView : accessBem.canView;
        const canViewChecklist = isFems ? accessFem.canAmend : accessBem.canAmend;
        // Common logic shared by both
        const baseLogic = assetCategoryType === "/assetsBEM" &&
          params.data?.assetRiskLevel !== "Low Risk" &&
          params.data?.status === "Functioning";

        const isCorrectYear = currentYear === 2026;
        const isWindow1 = isCorrectYear && (
          (currentMonth >= 5 && currentMonth <= 7) || // June (5), July (6), August (7)
          (currentMonth === 8 && currentDate <= 5)    // September (8) up to the 5th
        );
        const showRisk = baseLogic && isWindow1;

        // Condition 2: Every year Jan 1st to Jan 31st
        // Logic: Month is January
        const isWindow2 = (currentMonth === 0);
        const showRisk1 = baseLogic && isWindow2;

        return (
          <>
            {canEdit && (
              <CustomTooltip title="Edit">
                <IconButton
                  onClick={() => handleEdit(params.data, "Edit")}
                  data-testid="edit-button"
                >
                  <EditIcon />
                </IconButton>
              </CustomTooltip>
            )}

            {canView && (
              <CustomTooltip title="View">
                <IconButton
                  onClick={() => handleView(params.data, "View")}
                  data-testid="view-button"
                >
                  <VisibilityIcon />
                </IconButton>
              </CustomTooltip>
            )}

            {canDelete && (
              <CustomTooltip title="Delete">
                <IconButton
                  onClick={() => handleDelete(params.data)}
                  data-testid="delete-button"
                >
                  <DeleteIcon />
                </IconButton>
              </CustomTooltip>
            )}

            {showRisk && canViewChecklist && (
              <CustomTooltip title="Risk">
                <IconButton
                  onClick={() => handleRisk(params.data)}
                  data-testid="risk-button"
                >
                  <PriorityHighOutlinedIcon color="error" />
                </IconButton>
              </CustomTooltip>
            )}
          </>
        );
      },
    }

  ];

  const [fetchedQuarter, setFetchedQuarter] = useState("");
  const [fetchedYear, setFetchedYear] = useState(null);


  const handleRisk = async (data) => {
    setIsDialogOpen(true);
    setAssetRiskdata(data);

    const assetId = data?.assetId;
    if (!assetId) return;

    try {
      const token = getAuthToken('id_token');
      const endpoint = `${BemsGraph}/api/GraphAssetregister/GetBemassetchecklist/${assetId}`;

      const response = await axios.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Check if a record exists
      if (response?.data && response?.data?.length > 0) {
        const existingData = response?.data[0];

        // Bind the "Yes"/"No" strings back to booleans
        const mappedChecks = {
          patientImpact: existingData?.patientimpactrisk === "Yes",
          hazardRisk: existingData?.hazardrisk === "Yes",
          failedSafety: existingData?.failedsafetyperformance === "Yes",
          highRepairCost: existingData?.highrepaircost === "Yes",
          badCondition: existingData?.badphysicalcondition === "Yes",
          breakdownFreq: existingData?.breakdownfreq === "Yes",
        };

        setRiskChecks(mappedChecks);
        setAssetCondition(existingData?.assetCondition || "Good");
        setExistingChecklistId(existingData?.checklistId); // Store the ID for updating later
        setFetchedQuarter(existingData?.quarter);
        setFetchedYear(existingData?.year);
      } else {
        // API returned [] -> Reset to default values for a brand new save
        resetToDefaultChecks();
      }
    } catch (error) {
      console.error("Error fetching checklist data, falling back to defaults:", error);
      resetToDefaultChecks();
    }
  };

  const resetToDefaultChecks = () => {
    setRiskChecks({
      patientImpact: false,
      hazardRisk: false,
      failedSafety: false,
      highRepairCost: false,
      badCondition: false,
      breakdownFreq: false,
    });
    setAssetCondition("Good");
    setExistingChecklistId(null); // Clear ID since it's a new entry
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    resetToDefaultChecks();
  };

  const evaluateCondition = (checks) => {
    const { patientImpact, hazardRisk, failedSafety,
      highRepairCost, badCondition, breakdownFreq } = checks;

    // Rule #1: Auto Poor
    if (patientImpact || hazardRisk || failedSafety) {
      return "Poor";
    }

    // Rule #2: Tick count
    const tickCount = [highRepairCost, badCondition, breakdownFreq].filter(Boolean).length;
    if (tickCount >= 3) return "Poor";
    if (tickCount > 0) return "Fair";
    return "Good";
  };

  const handleCheckChange = (name) => {
    const updated = { ...riskChecks, [name]: !riskChecks[name] };
    setRiskChecks(updated);
    setAssetCondition(evaluateCondition(updated)); // update immediately
  };

  const getQuarterAndYear = () => {
    const now = new Date();
    const month = now.getMonth() + 1; // JS months are 0–11
    const year = now.getFullYear();

    let quarter = "";
    if (month >= 1 && month <= 3) quarter = "Q1";
    else if (month >= 4 && month <= 6) quarter = "Q2";
    else if (month >= 7 && month <= 9) quarter = "Q3";
    else quarter = "Q4";

    return { quarter, year };
  };

  const handleSaveRisk = () => {
    setRiskDialogOpen(true);

  };

  const [existingChecklistId, setExistingChecklistId] = useState(null);

  const confirmrisksave = async (assetRiskData) => {
    const { quarter, year } = getQuarterAndYear();

    const riskpayload = {
      patientimpactrisk: riskChecks.patientImpact,
      hazardrisk: riskChecks.hazardRisk,
      failedsafetyperformance: riskChecks.failedSafety,
      highrepaircost: riskChecks.highRepairCost,
      badphysicalcondition: riskChecks.badCondition,
      breakdownfreq: riskChecks.breakdownFreq,
      quater: quarter, // matches backend naming 'quater'
      year: year,
      riskscore: assetRiskData?.assetRisk || 0,
      assetage: assetRiskData?.assetAge || "",
      bemassetconditioncategoryId: assetCondition === "Good" ? 1 : assetCondition === "Fair" ? 2 : 3,
      bemassetregisterId: assetRiskData?.assetId,
      bemassetstatusId: assetRiskData?.assetstatus,
    };

    // RULE: Same Quarter & Year -> UPDATE (PUT). Different Quarter/Year or New -> SAVE (POST)
    // 'fetchedQuarter' and 'fetchedYear' should be stored in state inside your handleRisk function
    const isSameQuarterAndYear = existingChecklistId &&
      fetchedQuarter === quarter &&
      fetchedYear === year;

    if (isSameQuarterAndYear) {
      riskpayload.id = existingChecklistId; // Attach tracking ID for modification
    }

    try {
      const token = getAuthToken('id_token');
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      // Dynamically toggle URL and Method
      const endpoint = isSameQuarterAndYear
        ? `${BemsGraph}/api/bemassetchecklisthistories/${existingChecklistId}`
        : `${BemsGraph}/api/bemassetchecklisthistories`;

      await axios({
        method: isSameQuarterAndYear ? 'put' : 'post',
        url: endpoint,
        data: riskpayload,
        headers: config.headers,
      });

      closeDialog();
      setRiskDialogOpen(false);
      handleRefresh();

    } catch (error) {
      setRiskDialogOpen(false);
      setErrorRiskDialogOpen(true);
      setErrorRiskMessage(error?.response?.data?.detail || "An error occurred while saving.");
    }
  };
  // Navigate to Create a new AssetRegister page
  const handleAssetRegister = () => {
    const isAssetCreation = true; //this flag for showing the underwarranty
    const mergedPurchaseDetails = {
      ...initialPurchaseDetails,
      isAssetCreation,
    };
    // setting initial values to asset register page
    dispatch(gridValues({ values: {}, isEdit: false, isView: false }));
    dispatch(updateBasicDetails("UPDATE_BASIC_DETAILS", intialBaiscDetails));
    dispatch(
      updateAssetSpecification(
        "UPDATE_ASSET_SPECIFICATION",
        initailAssetSpecification
      )
    );
    dispatch(
      updatePurchaseDetails("UPDATE_PURCHASE_DETAILS", mergedPurchaseDetails)
    );
    dispatch(
      clearAttachmentDetails(
        "CLEAR_ATTACHMENT_DETAILS",
        initialAttachmentDetails
      )
    );
    navigate(`${assetCategoryType}/registration`, { state: { assetMode: "Create" } });
  };

  //Set the grid value filtered by workgroup id
  const filteredworkGroup = async (assetType, workgroupid, pageIndex, pageSize) => {
    setGridLoader(true);
    const checkFemorBem = assetCategoryType === "/assetsFEM" ? "fem" : "bem";
    try {

      const response = await AssetRepository.workgroupFilteredRows(
        assetType,
        workgroupid,
        filterModel, sortModel, pageIndex, pageSize
      );
      if (response) {
        setFilteredRows(response?.[0]?.[`${checkFemorBem}assetregisters`]);
        setRowCount(response?.[0]?.assetCount)
      }
    } catch (error) {
      console.error("Failed to fetch filtered work group data:", error);
    } finally {
      setGridLoader(false);
    }
  };

  const fetchWorkGroupData = async (workgroupid) => {
    try {
      setIsLoading(true);
      const checkFemorBem = assetCategoryType === "/assetsFEM" ? "fem" : "bem";
      const response = await AssetRepository.exportDataForWorkGroup(
        assetCategoryType,
        workgroupid,
        filterModel, sortModel
      );
      setExportData(response[0]?.[`${checkFemorBem}assetregisters`]);

    } catch (error) {
      console.error("Failed to fetch filtered work group data:", error);
    } finally {
      setIsLoading(false);
    }
  };


  // Fetch the Grid Values from API
  const fetchExportData = async () => {
    try {
      setIsLoading(true);
      const response = await AssetRepository.exportData(assetCategoryType, filterModel, sortModel);
      setExportData(response?.data);
    } catch (error) {
      console.error("Failed to fetch asset data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExportData = async () => {
    if (wgCode) {
      await fetchWorkGroupData(workGroupdetail?.id);
    } else {
      await fetchExportData();
    }
  };

  // Edit the Asset listing page
  const viewAssetApi = async (id) => {
    try {
      setIsLoading(true);
      const response = await AssetRepository.assetViewDetail(
        assetCategoryType,
        id
      );
      return response;
    } catch (error) {
      console.error("Fail to get the asset", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Edit Page from the assetList grid table
  const handleEdit = async (data, type) => {
    let Edit = type === "Edit" ? true : false;
    try {
      const editAssetbyId = await viewAssetApi(data?.assetId);
      const isAssetCreation = false; //this flag for not showing the underwarranty
      const mergedPurchaseDetails = { ...initialPurchaseDetails, isAssetCreation };
      const mergerowData = { ...editAssetbyId, timestamp: data?.timestamp || "" }
      if (editAssetbyId) {
        dispatch(gridValues({ values: mergerowData, isEdit: Edit, isView: !Edit }));
        dispatch(updateBasicDetails("UPDATE_BASIC_DETAILS", intialBaiscDetails));
        dispatch(updateAssetSpecification("UPDATE_ASSET_SPECIFICATION", initailAssetSpecification));
        dispatch(updatePurchaseDetails("UPDATE_PURCHASE_DETAILS", mergedPurchaseDetails));
        dispatch(clearAttachmentDetails("CLEAR_ATTACHMENT_DETAILS", initialAttachmentDetails));
        navigate(`${assetCategoryType}/registration`, { state: { ...data, id: data?.assetId, type: "Edit", assetMode: "Edit" } });
      } else {
        setIsError(true)
      }
    } catch (error) {
      setIsError(true)
      console.error("Fail to get the asset", error);
    }
  };

  // Handle the aseet View page from the assetList grid table
  const handleView = async (data, type) => {
    let View = type === "View" ? true : false;
    const viewAssetbyId = await viewAssetApi(data?.assetId);
    if (viewAssetbyId) {
      dispatch(gridValues({ values: viewAssetbyId, isEdit: !View, isView: View, updatedRows: rows, }));
      navigate("view", { state: { id: data?.assetId, type: "View", values: viewAssetbyId, isEdit: !View, isView: View, updatedRows: rows, assetCategoryType } });
    } else {
      setIsError(true);
    }
  };

  // Handle Delete Page from the assetList grid table
  const handleDelete = (row) => {
    setRowToDelete(row);
    setDeleteDialogOpen(true);
  };

  // Confirm Delete the asset from the assetList grid table
  const confirmDelete = async () => {
    let assetType;
    let checkFemorBem;
    if (assetCategoryType === '/assetsFEM') {
      assetType = FemsGraph;
      checkFemorBem = "fem";
    } else if (assetCategoryType === '/assetsBEM') {
      assetType = BemsGraph;
      checkFemorBem = "bem";
    } else {
      return;
    }
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      if (!rowToDelete || !rowToDelete?.assetId) {
        return;
      }
      await axios.delete(
        `${assetType}/api/${checkFemorBem}assetregisters/${rowToDelete?.assetId}`,
        config
      );
      const updatedRows = rows.filter(
        (row) => row?.assetId !== rowToDelete?.assetId
      );
      setFilteredRows(updatedRows);
    } catch (error) {
      if (error?.response && error?.response?.status === 400) {
        // Assuming 409 is the status code for "Conflict"
        setErrorMessage("The Asset Code  is Already in use");
      } else {
        setErrorMessage(
          "An error occurred while deleting the asset. Please try again."
        );
      }
    } finally {
      setDeleteDialogOpen(false);
      setRowToDelete({});
    }
  };
  // Handle Asset Card Click
  const handleAssetCardClick = async (wgCode) => {
    if (wgCode) {
      setWgCode(wgCode)
      let serviceType = service ? service : assetCategoryType
      const response = await AssetRepository.workGroupCodeDetails(
        serviceType,
        facilityId
      );

      const selectedGroup = response?.find(
        (item) => item?.wgcode === wgCode
      );

      let pageindex = pageIndex;
      let pagesize = pageSize;

      setWorkGroupDetail(selectedGroup);
      setActiveCard({
        [selectedGroup?.wgcode]: true, //set the workgroup code active when the user click the workgroup
      });
      await filteredworkGroup(assetCategoryType, selectedGroup?.id, pageindex, pagesize);
    } else {
      setFilteredRows(rows);
      setActiveCard({
        all: true,
      });
      setWorkGroupDetail([]);
      setWgCode(null);
      fetchData(assetCategoryType, pageIndex, pageSize, filterModel, sortModel);
    }
  };

  const handleRefresh = () => {
    setRiskChecks(
      {
        patientImpact: false,
        hazardRisk: false,
        failedSafety: false,
        highRepairCost: false,
        badCondition: false,
        breakdownFreq: false,
      }
    )
    setAssetCondition("Good");
    setPageIndex(1);
    setPageSize(10);
    setFilterModel([]);
    setSortModel([]);
    setActiveCard((prev) => {
      return Object.entries(prev).reduce(
        (updatedPrev, [key, value]) => {
          if (value) {
            updatedPrev[key] = false;
            updatedPrev["all"] = true;
          }
          return updatedPrev;
        },
        {}
      );
    });
    setWorkGroupDetail([]);
  };

  return (
    <>
      <PageLoader open={isLoading} />
      <PageTitle
        title={
          assetCategoryType === "/assetsFEM"
            ? "Asset Register - FEMS"
            : "Asset Register - BEMS"
        }
      />
      <Box mt={{ xs: 1, sm: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <DefaultCard>
              <AssetCard>
                <AssetCardItem
                  className={activeCard?.all ? "active" : " "}
                  sx={{ padding: { xs: 1, md: 2 } }}
                  onClick={() => handleAssetCardClick()}
                >
                  <Typography fontWeight="bold">All Assets</Typography>
                  <Typography variant="h2">{assetTotalCount}</Typography>
                </AssetCardItem>
                {workGroup &&
                  workGroup?.length > 0 &&
                  workGroup
                    .sort((a, b) => {
                      const matchWgCode = a.wgcode?.match(/\d+/); // Check the work group code
                      const matchWgDescription = b.wgcode?.match(/\d+/); // check the workgroupdescription
                      const wgCode = matchWgCode
                        ? parseInt(matchWgCode[0], 20)
                        : Number.MAX_SAFE_INTEGER; // Assign a high value if no digits
                      const wgDescription = matchWgDescription
                        ? parseInt(matchWgDescription[0], 20)
                        : Number.MAX_SAFE_INTEGER; // Assign a high value if no digits
                      return wgCode - wgDescription;
                    })
                    .map((wg) => (
                      <AssetCardItem
                        key={wg?.wgcode}
                        className={activeCard[wg.wgcode] ? "active" : ""}
                        sx={{ padding: { xs: 1, md: 2, sm: 2 } }}
                        onClick={() => handleAssetCardClick(wg.wgcode)}
                        data-testid="Asset-card-items"
                      >
                        <Typography fontWeight="bold">
                          {wg?.wgcode} - {wg?.wgdesc}
                        </Typography>
                        <Typography variant="h2">
                          {wg?.assetCount || 0}
                        </Typography>
                      </AssetCardItem>
                    ))}
              </AssetCard>
            </DefaultCard>
          </Grid>
        </Grid>
      </Box>
      {/* data grid */}
      <Box mt={{ xs: 1, sm: 2 }}>
        <DefaultCard>
          <Box>
            <Stack
              mb={1}
              direction="row"
              spacing={1}
              flexWrap="wrap"
              alignItems="center"
            >
              {workGroupdetail?.wgcode ? (
                <Typography variant="h5" sx={{ flexGrow: 1 }}>
                  {workGroupdetail?.wgcode}-{workGroupdetail?.wgdesc}
                  &nbsp;/&nbsp;Asset Count:{workGroupdetail?.assetCount}
                </Typography>
              ) : (
                <Typography variant="h5" sx={{ flexGrow: 1 }}>
                  {rows?.length > 0 && (
                    <>All Assets &nbsp;/&nbsp;Asset Count:{assetTotalCount}</>
                  )}
                </Typography>
              )}
              {(isFems ? accessFem.canCreate : accessBem.canCreate) && <Button
                variant="contained"
                onClick={handleAssetRegister}
                sx={{ marginTop: { xs: 1, md: 2 } }}
                data-testid="AssetRegister"
              >
                {" "}
                ASSET REGISTER{" "}
              </Button>}

              {/* {/ Export button and refresh button /} */}
              <RefreshExportButtons
                exportFunction={handleExportData}
                exportData={exportData}
                rows={rows}
                refData={gridApi}
                handleRefresh={() => handleRefresh()}
                title={`Asset Register ${assetCategoryType === "/assetsFEM" ? "FEMS" : "BEMS"}`}
              />
            </Stack>
          </Box>
          <CustomAgGrid
            refSet={gridApi}
            setGridApi={setGridApi}
            rows={filteredRows}
            columns={columnNames}
            // handleDelete={
            //   (isFems ? accessFem.canDelete : accessBem.canDelete)
            //     ? (id) => handleDelete(id)
            //     : null
            // }
            // handleEdit={
            //   (isFems ? accessFem.canEdit : accessBem.canEdit)
            //     ? (id) => handleEdit(id, "Edit")
            //     : null
            // }
            // handleView={
            //   (isFems ? accessFem.canView : accessBem.canView)
            //     ? (id) => handleView(id, "View")
            //     : null
            // }
            // handleRisk={assetCategoryType === "/assetsBEM" ? true : false}
            isLoading={gridLoader}
            //for pagination
            pagination={false}
            setFilterModel={setFilterModel}
            setSortModel={setSortModel}
            totalCount={rowCount}
            pageIndex={pageIndex}
            pageSize={pageSize}
            setPageIndex={setPageIndex}
            setPageSize={setPageSize}
          />
        </DefaultCard>
      </Box>
      <CloseButton />

      <Dialog open={isDialogOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            closeDialog(); // Only close if triggered explicitly
          }
        }}
        fullWidth
        maxWidth="xl" // widest breakpoint
        sx={{
          "& .MuiDialog-paper": {
            width: { xs: "95vw", sm: "90vw", md: "80vw", lg: "70vw", xl: "60vw" },
            maxWidth: "none",
            height: 210
          },
        }}>
        <DialogTitle sx={{ fontWeight: 800, fontSize: 20 }}>
          Annual Asset Condition Evaluation Checklist (Moderate/High Risk Asset)
          <Box sx={{ float: "right" }}>
            {assetCondition === "Good" && <Chip label="Good" color="success" />}
            {assetCondition === "Fair" && <Chip label="Fair" color="warning" />}
            {assetCondition === "Poor" && <Chip label="Poor" color="error" />}
          </Box>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={2}>
              <FormControlLabel
                control={<Checkbox checked={riskChecks.patientImpact} onChange={() => handleCheckChange("patientImpact")} />}
                label={<Typography sx={{ fontWeight: 600 }}>Patient Impact Risk</Typography>}
              />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                control={<Checkbox checked={riskChecks.hazardRisk} onChange={() => handleCheckChange("hazardRisk")} />}
                label={<Typography sx={{ fontWeight: 600 }}>Hazard Risk</Typography>}
              />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                control={<Checkbox checked={riskChecks.failedSafety} onChange={() => handleCheckChange("failedSafety")} />}
                label={<Typography sx={{ fontWeight: 600 }}>Failed Safety / Performance</Typography>}
              />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                control={<Checkbox checked={riskChecks.highRepairCost} onChange={() => handleCheckChange("highRepairCost")} />}
                label={<Typography sx={{ fontWeight: 600 }}>High Repair Cost</Typography>}
              />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                control={<Checkbox checked={riskChecks.badCondition} onChange={() => handleCheckChange("badCondition")} />}
                label={<Typography sx={{ fontWeight: 600 }}>Bad Physical Condition</Typography>}
              />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                control={<Checkbox checked={riskChecks.breakdownFreq} onChange={() => handleCheckChange("breakdownFreq")} />}
                label={<Typography sx={{ fontWeight: 600 }}>Breakdown Freq &gt; 5 times/year</Typography>}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button color="primary" variant="contained" onClick={() => handleSaveRisk()}>Save</Button>
          <Button color="primary" variant="outlined" onClick={closeDialog}>Cancel</Button>
        </DialogActions>
      </Dialog>


      <CustomDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={confirmDelete}
        title="Confirm Delete"
        content="Are you sure you want to delete this asset?"
        cancelBtn="Cancel"
        confirmBtn="Delete"
      />
      <CustomDialog
        open={riskDialogOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setRiskDialogOpen(); // Only close if triggered explicitly
          }
        }}
        onConfirm={() => confirmrisksave(assetRiskData)}
        title="Confirm"
        content="Are you sure you want to Save the Risk Managment?"
        cancelBtn="No"
        confirmBtn="Yes"
      />
      <CustomDialog
        open={!!errorMessage}
        onClose={() => setErrorMessage("")}
        onConfirm={() => setErrorMessage("")}
        title="Warning !"
        content={errorMessage}
        cancelBtn="Cancel"
        confirmBtn="Ok"
      />

      <CustomDialog
        open={errorRiskDialogOpen}
        onClose={() => setErrorRiskDialogOpen("")}
        onConfirm={() => {
          setErrorRiskDialogOpen(false);

        }}
        title="Warning !"
        content={errorRiskMessage}
        confirmBtn="Ok"
      />
      <CustomAlert
        open={isError}
        onClose={() => setIsError(false)}
        onConfirm={() => setIsError(false)}
        content={"Something Went Wrong. Please try again later."}
        confirmBtn={"OK"}
      />

    </>
  );
};

export default AssetList;
